import { render, staticRenderFns } from "./PageProfile.vue?vue&type=template&id=8f5d1658&scoped=true&lang=pug&"
import script from "./PageProfile.vue?vue&type=script&lang=js&"
export * from "./PageProfile.vue?vue&type=script&lang=js&"
import style0 from "./PageProfile.vue?vue&type=style&index=0&id=8f5d1658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5d1658",
  null
  
)

export default component.exports